<template>
  <footer class="ips-login__footer">
    <div class="txt-center">
      <span class="fs-12">版权所有 @一爱城市服务</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "LoginFooter"
  , data() {
    return {}
  }
  , computed: {}
  , methods: {}
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/footer";
</style>
